import React, { useRef, useEffect } from "react";
import { ReactComponent as RightArrowInWhite } from "assets/svgs/right-arrow.svg";
import { ReactComponent as LeftArrowInWhite } from "assets/svgs/left-arrow.svg";
import { ReactComponent as Closy } from "assets/svgs/closy.svg";
import Image from "components/image";
import Modal from "components/modal";
import clsx from "clsx/lite";

// TODO: allow custom dots components to be passed in.
const Dots = ({
	items,
	className,
	dotStyle = "",
	onDotClick,
	activeDot,
	// DotLayout = null,
}) => {
	// const DotComponent = (props) => <DotLayout {...props} /> || ((props) => <span {...props} />);

	return (
		<div className={className}>
			{items.map((item, index) => (
				<span
					key={index}
					className={clsx((activeDot === index) ? "bg-orange" : "bg-white", "rounded-full size-4", dotStyle)}
					role="button"
					onClick={(event) => {
						event.stopPropagation();

						if (onDotClick) onDotClick(event, item, index);
					}}
				/>
			))}
		</div>
	);
};

const GalleryModal = ({
	images,
	setImageIndex,
	imageIndex,
	setModalOpen,
	isModalOpen,
	className,
}) => {
	const modalContentRef = useRef(null);

	const handleArrowClick = (side) => (event) => {
		event.stopPropagation();
		const lastIndex = images.length - 1;

		if (side === "left") {
			if (imageIndex === 0) {
				setImageIndex(lastIndex);
				return;
			}

			setImageIndex((prev) => (prev -= 1));
			return;
		}

		if (imageIndex === lastIndex) {
			setImageIndex(0);
			return;
		}

		setImageIndex((prev) => (prev += 1));
	};

	const handleClickOutside = (event) => {
		if (modalContentRef.current && !modalContentRef.current.contains(event.target)) {
			setModalOpen(false);
		}
	};

	useEffect(() => {
		if (isModalOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isModalOpen]);

	return (
		<Modal
			bodyClassName="relative"
			isOpen={isModalOpen}
			className={clsx("overflow-visible !size-[600px]", className)}
			hideHeader
		>
			<div
				className="select-none max-w-3xl cursor-zoom-out"
				onClick={() => setModalOpen(false)}
				ref={modalContentRef}
			>
				<Image
					role="presentation"
					image={images[imageIndex]}
				/>

				<button
					role="button"
					onClick={() => setModalOpen(false)}
					className="rounded-full bg-white flex items-center justify-center size-10 absolute -top-15 -right-20"
				>
					<Closy />
				</button>

				<div className="dots-wrapper">
					<div
						role="button"
						className="left-arrow-bwv-zoom relative"
						onClick={handleArrowClick("left")}
					>
						<LeftArrowInWhite
							role="presentation"
							aria-hidden="true"
							className="absolute top-1/2 left-1/2 transform -translate-x-[56.33%] -translate-y-1/2"
						/>
					</div>

					<Dots
						items={images}
						activeDot={imageIndex}
						dotStyle="cursor-pointer !size-3"
						className="flex items-center gap-3 pb-1"
						onDotClick={(_, __, index) => {
							setImageIndex(index);
						}}
					/>

					<div
						role="button"
						className="right-arrow-bwv-zoom relative"
						onClick={handleArrowClick("right")}
					>
						<RightArrowInWhite
							role="presentation"
							aria-hidden="true"
							className="absolute top-1/2 left-1/2 transform -translate-x-1/3 -translate-y-1/2"
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default GalleryModal;